import React from 'react';
import PropTypes from 'prop-types';

import styles from './styles.scss';

const VIPLetter = (props) => {
  const {
    primaryContactDisplayName, amenityProgram, vendorName, from, travelerNames,
    displayStartDate, displayEndDate, category, bedType, confirmationNumber,
    specialRequests, transferArrangements, arrivalDetails, departureDetails,
    insideCircle, iata,
  } = props;

  return (<div className={styles.vipLetter}>
    <p>Hello {primaryContactDisplayName},</p>
    <p>
      I would like to inform you of a {amenityProgram} client of ours
      that will be staying with you soon at {vendorName}. I hope you can
      make a note of the following items for them, and I know they will
      be in good hands once they arrive!
    </p>
    <p>
      The guest details are listed below. Please do not hesitate to
      contact us if you need any further information.
    </p>
    <p>Many thanks!<br />{from}</p>
    <p>
      {travelerNames}<br />
      {displayStartDate} to {displayEndDate} in a {category} {bedType}<br />
      Confirmation #{confirmationNumber}
    </p>
    <ul>
      <li>
        Thank you for extending any
        {amenityProgram === 'VIP' ? '' : ` ${amenityProgram} and`} VIP
        services wherever possible to help the guests enjoy their stay
      </li>
      <li>We appreciate any upgrades that may be applied</li>
      {specialRequests.map((request, index) => <li key={index}>
        {request}
      </li>)}
      <li>
        {transferArrangements}
        {arrivalDetails || departureDetails ? <ul>
          {arrivalDetails === '' ? null : <li><b>Arriving:</b> {arrivalDetails}</li>}
          {departureDetails === '' ? null : <li><b>Departing:</b> {departureDetails}</li>}
        </ul> : null}
      </li>
      <li>
        Please sign any welcome notes from
        &quot;{insideCircle ? 'David' : 'Team'} Ourisman&quot;.
      </li>
      <li>For your reference, our IATA is #{iata}</li>
    </ul>
  </div>);
};

VIPLetter.propTypes = {
  primaryContactDisplayName: PropTypes.string.isRequired,
  amenityProgram: PropTypes.string.isRequired,
  vendorName: PropTypes.string.isRequired,
  from: PropTypes.string.isRequired,
  travelerNames: PropTypes.arrayOf(PropTypes.object).isRequired,
  displayStartDate: PropTypes.string.isRequired,
  displayEndDate: PropTypes.string.isRequired,
  category: PropTypes.string.isRequired,
  bedType: PropTypes.string.isRequired,
  confirmationNumber: PropTypes.string.isRequired,
  specialRequests: PropTypes.arrayOf(PropTypes.string).isRequired,
  transferArrangements: PropTypes.string.isRequired,
  arrivalDetails: PropTypes.string.isRequired,
  departureDetails: PropTypes.string.isRequired,
  insideCircle: PropTypes.bool.isRequired,
  iata: PropTypes.string.isRequired,
};

export default VIPLetter;



// WEBPACK FOOTER //
// /src/components/Segments/VIPLetter.js